var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0476 41V19.4127",
    stroke: "url(#paint0_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4602 32.746V9.25397",
    stroke: "url(#paint1_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63501 32.746V9.25397",
    stroke: "url(#paint2_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0476 14.3333V1",
    stroke: "url(#paint3_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0476 18.7778L1 9.88889",
    stroke: "url(#paint4_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0476 18.7778L39.0952 9.88889",
    stroke: "url(#paint5_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0476 1L39.0952 9.88889",
    stroke: "url(#paint6_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0476 1L1 9.88889",
    stroke: "url(#paint7_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0476 41L1 32.1111",
    stroke: "url(#paint8_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0476 41L39.0952 32.1111",
    stroke: "url(#paint9_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0476 23.2222L39.0952 32.1111",
    stroke: "url(#paint10_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0476 23.2222L1 32.1111",
    stroke: "url(#paint11_linear_5_90)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_90",
    x1: 20.5476,
    y1: 19.4127,
    x2: 20.5476,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_90",
    x1: 38.9602,
    y1: 9.25397,
    x2: 38.9602,
    y2: 32.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_90",
    x1: 2.13501,
    y1: 9.25397,
    x2: 2.13501,
    y2: 32.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_90",
    x1: 20.5476,
    y1: 1,
    x2: 20.5476,
    y2: 14.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_90",
    x1: 10.5238,
    y1: 9.88889,
    x2: 10.5238,
    y2: 18.7778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_90",
    x1: 29.5714,
    y1: 9.88889,
    x2: 29.5714,
    y2: 18.7778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_90",
    x1: 29.5714,
    y1: 1,
    x2: 29.5714,
    y2: 9.88889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_90",
    x1: 10.5238,
    y1: 1,
    x2: 10.5238,
    y2: 9.88889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_90",
    x1: 10.5238,
    y1: 32.1111,
    x2: 10.5238,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_90",
    x1: 29.5714,
    y1: 32.1111,
    x2: 29.5714,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5_90",
    x1: 29.5714,
    y1: 23.2222,
    x2: 29.5714,
    y2: 32.1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5_90",
    x1: 10.5238,
    y1: 23.2222,
    x2: 10.5238,
    y2: 32.1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2297BE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.b08a3391af1dfbc9217ae9fa58849318.svg";
export { ForwardRef as ReactComponent };